export const defaultNiceScrollConfig = {
    cursorcolor: "#d6d6d6",
    cursoropacitymin: 1,
    emulatetouch: true
}